// extracted by mini-css-extract-plugin
export var relatedWrapper = "RelatedContent-module--related-wrapper--1IjMt";
export var customEdgePadding = "RelatedContent-module--custom-edge-padding--1z17p";
export var relatedCopy = "RelatedContent-module--related-copy--TWnd3";
export var descriptionWrapper = "RelatedContent-module--description-wrapper--2rr86";
export var navBtns = "RelatedContent-module--navBtns--2OAZx";
export var carouselBtns = "RelatedContent-module--carouselBtns--3UEKC";
export var ctaButtonGroup = "RelatedContent-module--cta-button-group--ochcD";
export var viewAllButton = "RelatedContent-module--view-all-button--CY-1U";